import { Button, Col, Descriptions, List, Row, Tag, Typography } from "antd";
import { createComponentStore, useStoreState } from "easy-peasy";
import React, { useEffect, useState } from "react";
import { ContractStoreModel } from "store/models/contracts";
import { ACTION_TYPES } from "store/models/general-crud";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Zoom from "react-reveal/Zoom";

import WidgetContainer from "./components/widget-container";
import RentableAreaChart from "./components/rentableareas-chart";
import LodgingRentPayemntChart from "./components/lodgingrentpayments-chart";
import TotalContractValuesChart from "./components/totalcontractValues";
import Clock from "./components/clock";

import { PaymentStoreModel } from "store/models/payments";
import { formatCurrency } from "Utils";
import DashboardModel from "Store/models/dashboard";

const { Title } = Typography;
const useContractStore = createComponentStore(ContractStoreModel);
const usePaymentStore = createComponentStore(PaymentStoreModel);

const useTotalValuesStore = createComponentStore(
  DashboardModel("totalcontractvalues")
);

export default function Home({ ...props }) {
  const { user } = useStoreState((store) => store.auth);
  const [contractStore, contractActions] = useContractStore();
  const [paymentStore, paytentActions] = usePaymentStore();
  const [totalValuesStore, totalValuesActions] = useTotalValuesStore();

  useEffect(() => {
    contractActions.search({ sort: "createdAt,DESC", size: 5 });
    paytentActions.search({ sort: "createdAt,DESC", size: 5 });
    totalValuesActions.fetch({
      month: moment().get("M") + 1,
      year: moment().get("Y"),
    });
  }, [contractActions, paytentActions]);

  const getContractTotal = (item) => {
    if (item.cashFlows.length <= 0) return 0;

    const total = item.cashFlows.reduce(
      (curr, prev) => curr + prev.documentAmount,
      0
    );

    return formatCurrency(total, item.cashFlows[0].documentCurrency);
  };

  return (
    <div style={{ margin: "24px" }}>
      <Row>
        <Col xs={24} sm={12} lg={6}>
          <Zoom top>
            <WidgetContainer
              color="#44AFF2"
              backgroundColor="#44AFF2"
              title={`Hoş Geldiniz, ${user?.name} ${user?.surname}`}
              icon={() => <FontAwesomeIcon icon={["fas", "house-user"]} />}
            >
              <Clock />
            </WidgetContainer>
          </Zoom>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Zoom top>
            <WidgetContainer
              color="#4EA696"
              backgroundColor="#4EA696"
              title={`${moment().format("MM/YY")} Nakit Akışı`}
              icon={() => <FontAwesomeIcon icon={["fas", "coins"]} />}
            >
              <p style={{ textAlign: "right", color: "white", fontSize: 20 }}>
                {formatCurrency(
                  totalValuesStore.data.length > 0
                    ? totalValuesStore.data[0].totalCashflow
                    : 0,
                  "TURKISH_LIRA"
                )}
              </p>
            </WidgetContainer>
          </Zoom>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Zoom top>
            <WidgetContainer
              color="#F24F13"
              backgroundColor="#F24F13"
              title={`${moment().format("MM/YY")} Tahsilatlar`}
              icon={() => <FontAwesomeIcon icon={["fas", "cash-register"]} />}
            >
              <p style={{ textAlign: "right", color: "white", fontSize: 20 }}>
                {formatCurrency(
                  totalValuesStore.data.length > 0
                    ? totalValuesStore.data[0].totalPayment
                    : 0,
                  "TURKISH_LIRA"
                )}
              </p>
            </WidgetContainer>
          </Zoom>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Zoom top>
            <WidgetContainer
              color="#4A608C"
              backgroundColor="#4A608C"
              title={`Güncel Borç/Alacak`}
              icon={() => (
                <FontAwesomeIcon icon={["fas", "balance-scale-left"]} />
              )}
            >
              <p style={{ textAlign: "right", color: "white", fontSize: 20 }}>
                {`${formatCurrency(
                  totalValuesStore.data.length > 0
                    ? totalValuesStore.data[0].totalCredit
                    : 0,
                  "TURKISH_LIRA"
                )} / ${formatCurrency(
                  totalValuesStore.data.length > 0
                    ? totalValuesStore.data[0].totalDebt
                    : 0,
                  "TURKISH_LIRA"
                )}`}
              </p>
            </WidgetContainer>
          </Zoom>
        </Col>
        <Col xs={24} lg={16}>
          <TotalContractValuesChart />
        </Col>
        <Col xs={24} lg={8}>
          <RentableAreaChart />
        </Col>
        <Col xs={24} md={12} lg={6}>
          <WidgetContainer
            height="40vh"
            title="Son Sözleşmeler"
            overflow="auto"
            icon={() => <FontAwesomeIcon icon={["fas", "file-contract"]} />}
            actions={[
              <Button>
                <Link to={`/panel/islemler/sozlesmeler`}>Hepsini Gör</Link>
              </Button>,
            ]}
          >
            <List
              loading={contractStore.process === ACTION_TYPES.FETCHING_DATA}
              dataSource={contractStore.data?.content}
              renderItem={(item, index) => {
                return (
                  <List.Item
                    className="customized"
                    key={item.id}
                    style={{ position: "relative" }}
                  >
                    <List.Item.Meta
                      title={
                        <Link
                          to={`/panel/islemler/sozlesmeler/${item.id}/detay`}
                        >{`${item.partner.name} ${item.partner.surname}`}</Link>
                      }
                      description={item.type.description}
                    />
                    {item.rentableAreas
                      .map(
                        (rentableArea) =>
                          (rentableArea.rentableArea?.code || "") +
                          "-" +
                          (rentableArea.rentableArea?.description || "")
                      )
                      .join(",")}

                    <Tag
                      color="blue"
                      style={{
                        position: "absolute",
                        top: 12,
                        right: 0,
                        fontSize: 14,
                      }}
                    >
                      {getContractTotal(item)}
                    </Tag>
                  </List.Item>
                );
              }}
            />
          </WidgetContainer>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <WidgetContainer
            height="40vh"
            title="Son Tahsilatlar"
            overflow="auto"
            icon={() => <FontAwesomeIcon icon={["fas", "cash-register"]} />}
          >
            <List
              loading={paymentStore.process === ACTION_TYPES.FETCHING_DATA}
              dataSource={paymentStore.data?.content}
              renderItem={(item, index) => {
                return (
                  <List.Item
                    className="customized"
                    key={item.id}
                    style={{ position: "relative" }}
                  >
                    <List.Item.Meta
                      title={
                        <Link
                          to={`/panel/islemler/sozlesmeler/${item.contract.id}/detay`}
                        >{`${item.contract.code}-${item.contract.type.description}`}</Link>
                      }
                      description={`${item.contract.partner.name} ${item.contract.partner.surname}`}
                    />
                    {item.contract.rentableAreas
                      .map(
                        (rentableArea) =>
                          (rentableArea.rentableArea?.code || "") +
                          "-" +
                          (rentableArea.rentableArea?.description || "")
                      )
                      .join(",")}

                    <Tag
                      color="blue"
                      style={{
                        position: "absolute",
                        top: 12,
                        right: 0,
                        fontSize: 14,
                      }}
                    >
                      {formatCurrency(item.amount, item.currency)}
                    </Tag>
                  </List.Item>
                );
              }}
            />
          </WidgetContainer>
        </Col>
        <Col xs={24} lg={12}>
          <LodgingRentPayemntChart />
        </Col>
      </Row>
    </div>
  );
}
